
import { computed, defineComponent } from "vue";
import useStore from "@/composables/useStore";

export default defineComponent({
    name: "BuyButton",
    setup() {
        const store = useStore();
        const selectedDiamond = computed(
            () => store.state.userSelection.diamond
        );

        function handleFormSubmit(e: Event) {
            const cart = document.querySelector("shopify-cart");

            if (cart) {
                e.preventDefault();
                //@ts-expect-error unknown custom element
                cart.addItemFromForm(e.target);
            }
        }

        return {
            selectedDiamond,
            handleFormSubmit
        };
    }
});
